import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const AdminRequestModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "AdminRequestModalContainer" */
      './AdminRequestModalContainer'
    ),
  loading: LoadingModal,
});
